import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import Select from "react-select";
import { apiService } from '../../services/apiService';
import 'react-phone-number-input/style.css'
import PhoneInput from 'react-phone-number-input'
import { getCountryCallingCode } from 'libphonenumber-js';
function CommunityMemberAdd() {
    const navigate = useNavigate();
    const allowedCountries = ['US', 'IN', 'CA', 'DE', 'AU', 'GB', 'PK'];
    const maxPhoneLengths = { 
        US: 10,  // United States
        IN: 10,  // India
        CA: 10,  // Canada
        DE: 11,  // Germany
        AU: 9,   // Australia
        GB: 10,  // United Kingdom
        PK: 10   // Pakistan
    };
    const [formData, setFormData] = useState({
        view_link:"/community-member/view/",
        first_name:"",
        last_name:"",
        email:"",
        secondary_email:"",
        other_email:"",
        phone_number:"",
        secondary_phone_number:"",
        other_phone_number:"",
        source:[],
        living_city:"",
        living_state:"",
        living_country:"",
        level:"",
        comments:"",
        jobseeker_id:"",
        referred_by:"",
    });
    const [country, setCountry] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedsource, setSelectedSource] = useState([]);
    const [selectedreferredId, setSelectedrefId] = useState(null);
    const [selectedjobseekId, setSelectedjobseekId] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [errors, setErrors] = useState({});
    const [btnloading, setBtnLoading] = useState(false);
    const [errorsmessage, setErrorMessage] = useState('');
    const [rolesOptions, setRolesOptions] = useState([]);
    const [rolesOptionsfilter, setRolesOptionsfilter] = useState([]);
    const [jobseekerOptions, setjobseekerOptions] = useState([]);
    const [opendata, setOpendata] = useState(false);
        useEffect(() => {
            const fetchData = async () => {
                const response = await apiService.postRequest('countries-list?module=community_member');
                if (response.success) {
                    setCountry(response.data);
                }
            };
            fetchData();
        }, []);
        useEffect(() => {
            if (formData.living_country) {
                const fetchData = async () => {
                    const response = await apiService.postRequest(`states-list/${formData.living_country}`);
                    if (response.success) {
                        setStates(response.data);
                        setSelectedState(null);
                    }else{
                        if(response && response.authenticate === false){
                            await apiService.postRequest('/auth/logout');
                            localStorage.clear();
                            sessionStorage.clear();
                            window.location.href = '/login';
                        }
                    }
                };
                fetchData();
            }
        }, [formData.living_country]);
        useEffect(() => {
            if (formData.living_state && formData.living_country) {
                const fetchData = async () => {
                    const param ={
                        'country_code' : formData.living_country
                    }
                    const response = await apiService.postRequest(`cities-list/${formData.living_state}`,param);
                    if (response.success) {
                        setCities(response.data || []);
                        setSelectedCity(null);
                    }else{
                        if(response && response.authenticate === false){
                            await apiService.postRequest('/auth/logout');
                            localStorage.clear();
                            sessionStorage.clear();
                            window.location.href = '/login';
                        }
                    }
                };
                fetchData();
            }
        }, [formData.living_state, formData.living_country]);
    // Fetch roles data from the API
    useEffect(() => {
        const fetchRoles = async () => {
            try {
                const response = await apiService.getRequest('/community-members-list');
                if(response && response.success === true){
                    const options = response.data.map((role) => ({
                        value: role.id,  // Store role id instead of name
                        label: role.first_name + " " + role.last_name,
                    }));
                    setRolesOptions(options);
                }
            } catch (error) {
                console.error('Error fetching roles:', error);
            }
        };
        fetchRoles();
    }, []);
    useEffect(() => {
        const fetchDataseeker = async () => {
            const response = await apiService.postRequest('admin/jobseekers-list');
            if (response.success) {
                const options = response.data.map((role) => ({
                    value: role.id,  // Store role id instead of name
                    label: role.first_name + " " + role.last_name,
                }));
                const optionsfillter = response.data.map((role) => ({
                    id: role.id,
                    first_name: role.first_name,
                    last_name: role.last_name,
                }));
                setRolesOptionsfilter(optionsfillter);
                setjobseekerOptions(options);
            }else{
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        };
        fetchDataseeker();
    }, []);
    const handleSourceChange = (selectedOptions) => {
        setSelectedSource(selectedOptions);
        if (selectedOptions.some(opt => opt.value === 'Jobseeker')) {
            setOpendata(true);
            setFormData(prevFormData => ({
                ...prevFormData,
                source: selectedOptions ? selectedOptions.map(option => option.label) : [], // Store as an array
            }));
        } else {
            setOpendata(false);
            setFormData({
                ...formData,
                source: selectedOptions ? selectedOptions.map(option => option.label) : [], // Store as an array
                jobseeker_id: "",
                first_name: "",
                last_name: "",
            })
            setSelectedjobseekId(null);
        }
        // Clear roles error
        if (errors.source) {
            setErrors({ ...errors, source: '' });
        }
    };
    const handleCountryChange = (selectedOption) => {
        setSelectedCountry(selectedOption);
        handleInputChange({
            target: {
                name: 'living_country',
                value: selectedOption ? selectedOption.value : ''
            }
        });
        // Clear the living_city field when living_state is changed
        setSelectedState(null);
        setSelectedCity(null);
    };
    const handleStateChange = (selectedOption) => {
        setSelectedState(selectedOption);
        handleInputChange({
            target: {
                name: 'living_state',
                value: selectedOption ? selectedOption.value : ''
            }
        });
        // Clear the living_city field when living_state is changed
        setSelectedCity(null);
    };

    const handleCityChange = (selectedOption) => {
        setSelectedCity(selectedOption); // Update living_city
        handleInputChange({
            target: {
                name: 'living_city',
                value: selectedOption ? selectedOption.value : ''
            }
        });
    };
    
    const handlePhoneChange = (value, name) => {
        if (value) {
            const country = allowedCountries.find(
                (c) => value.startsWith(`+${getCountryCallingCode(c)}`)
            ) || 'US';

            const maxLength = maxPhoneLengths[country];
            const phoneWithoutCode = value.replace(`+${getCountryCallingCode(country)}`, '').replace(/\D/g, '');

            if (phoneWithoutCode.length <= maxLength) {
                handleInputChange({ target: { name, value } });
            }
        } else {
            handleInputChange({ target: { name, value: '' } });
        }
    };

    const handleKeyDown = (event, name) => {
        const { key } = event;
        const currentValue = formData[name] || '';
        const country = allowedCountries.find(
            (c) => currentValue.startsWith(`+${getCountryCallingCode(c)}`)
        ) || 'US';

        const maxLength = maxPhoneLengths[country];
        const phoneWithoutCode = currentValue.replace(`+${getCountryCallingCode(country)}`, '').replace(/\D/g, '');

        if (phoneWithoutCode.length >= maxLength && /\d/.test(key)) {
            event.preventDefault();
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        // Clear the error for the changed field
        if (errors[name]) {
            setErrors({ ...errors, [name]: '' });
        }
    };
    const handleRoleChange = (selectedOptions) => {
        setSelectedrefId(selectedOptions);
        handleInputChange({
            target: {
                name: 'referred_by',
                value: selectedOptions ? selectedOptions.value : ''
            }
        });
        if (errors.referred_by) {
            setErrors({ ...errors, referred_by: '' });
        }
    };
    const handlejobseekerChange = (selectedOptions) => {
        setSelectedjobseekId(selectedOptions);
        if (selectedOptions && opendata) {
            const selectedId = selectedOptions.value;
            const matchedRole = rolesOptionsfilter.find(role => role.id === selectedId);
            if (matchedRole){
                setFormData({
                    ...formData,
                    jobseeker_id:matchedRole.id,
                    first_name: matchedRole.first_name,
                    last_name: matchedRole.last_name,
                })
            }
        } else {
            setFormData({
                ...formData,
                jobseeker_id: "",
                first_name: "",
                last_name: "",
            })
        }
        if (errors.jobseeker_id || errors.first_name || errors.last_name) {
            setErrors({ ...errors, jobseeker_id: '',first_name: '', last_name: '', });
        }
    };

    // Basic validation logic
    const validate = () => {
        const newErrors = {};
        if (formData.source.length === 0) newErrors.source = 'Source is required';
        if(opendata){
            if (!formData.jobseeker_id) newErrors.jobseeker_id = 'Jobseeker is required';
        }
        if(rolesOptions && rolesOptions.length !== 0){
            if (!formData.referred_by) newErrors.referred_by = 'Referred by is required';
        }
        if(!opendata){
            if (!formData.first_name) newErrors.first_name = 'First name is required';
            if (formData.first_name && formData.first_name.length < 3) {
                newErrors.first_name = "First name be at least 3 characters long";
            }else if (formData.first_name && formData.first_name.length > 200) {
                newErrors.first_name = ['First name be less than 200 characters long.'];
            }
            if (!formData.last_name) newErrors.last_name = 'Last name is required';
            if (formData.last_name && formData.last_name.length > 200) {
                newErrors.last_name = ['Last name be less than 200 characters long.'];
            } 
        }
        if (formData.comments && formData.comments.length < 3) {
            newErrors.comments = "Comments be at least 3 characters long";
        }else if (formData.comments && formData.comments.length > 4000) {
            newErrors.comments = ['Comments be less than 4000 characters long.'];
        }
        if(!formData.phone_number && !formData.email){
            newErrors.phone_number = ['Either Phone number or Email is required.'];
            newErrors.email = ['Either Email or Phone number is required.'];
        }
        setErrorMessage("Please fix the errors before proceeding.");
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;
        
        setErrorMessage("");
        setBtnLoading(true);
        try {
            const response = await apiService.postRequest('/community-members', formData);
            if (response && response.success === true) {
                navigate('/community-member');
                toast(response.message);
            } else {
                setErrorMessage(response.message || "Failed. Please try again");
                if (response.errors) {
                    setErrors(response.errors);
                }
                if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error adding user:', error);
        } finally {
            setBtnLoading(false);
        }
    };
    const sanitizeAndDisplayHTML = (html) => {
        const sanitizedHTML = html
        return sanitizedHTML;
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{sm:12}} container className="main_jobseeker">
                <Grid size={{sm:12}} container alignItems="center">
                    <Grid size={{md:12,xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Community Member</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/community-member")}>Community Member</b><FontAwesomeIcon className='angleright' icon={faAngleRight} /> Create Community Member</span>
                    </Grid>
                </Grid>
                <Grid size={{md:12,xs:12}} container justifyContent="flex-end" alignItems="center" className="mt-5">
                    <Grid size={{md:12,xs:12}} justifyContent="space-between" alignItems="center" container className="memberser_heads">
                        <h5>Create Community Member</h5>
                    </Grid>
                    <Grid size={{xs:12}} container className="regiter_inputs i94validateinput">
                    <form className='row justify-content-center w-100' onSubmit={handleSubmit}>
                        <Grid size={{sm:12,xs:12}} container justifyContent="space-between">
                            <Grid size={{sm:12,xs:12}} container justifyContent="space-between">
                                <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                    <span>Source<small className='red_starimpo'>*</small></span>
                                    <Select
                                        isMulti
                                        name="source"
                                        value={selectedsource}
                                        onChange={handleSourceChange}
                                        options={[
                                            { value: "Jobseeker", label: "Jobseeker" },
                                            { value: "Supplier", label: "Supplier" },
                                            { value: "Independent", label: "Independent" },
                                        ]}
                                        className="basic-multi-select select_withsearch"
                                        classNamePrefix="select"
                                        placeholder="Choose Source..."
                                    />
                                    {errors.source && <p style={{color:"red"}}>{errors.source}</p>}
                                </Grid>
                            </Grid>
                            {opendata && 
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                <span>Jobseeker<small className='red_starimpo'>*</small></span>
                                <Select
                                    name="jobseeker_id"
                                    value={selectedjobseekId}
                                    onChange={handlejobseekerChange}
                                    options={jobseekerOptions}
                                    className="basic-multi-select select_withsearch"
                                    classNamePrefix="select"
                                    placeholder="Choose Jobseeker..."
                                />
                                {errors.jobseeker_id && <p style={{color:"red"}}>{errors.jobseeker_id}</p>}
                            </Grid>
                            }
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                <span>Referred By{rolesOptions && rolesOptions.length === 0 ? "" : <small className='red_starimpo'>*</small>}</span>
                                <Select
                                    name="referred_by"
                                    value={selectedreferredId}
                                    onChange={handleRoleChange}
                                    options={rolesOptions}
                                    className="basic-multi-select select_withsearch"
                                    classNamePrefix="select"
                                    placeholder="Choose Referred By..."
                                />
                                {errors.referred_by && <p style={{color:"red"}}>{errors.referred_by}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                <span>First Name {!opendata &&<small className='red_starimpo'>*</small>}</span>
                                <input type="text" minLength="3" maxLength="201" disabled={opendata} name="first_name" value={formData.first_name} onChange={handleInputChange} onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}/>
                                {errors.first_name && <p style={{color:"red"}}>{errors.first_name}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                <span>Last Name {!opendata &&<small className='red_starimpo'>*</small>}</span>
                                <input type="text" maxLength="201" disabled={opendata} name="last_name" value={formData.last_name} onChange={handleInputChange} onInput={(e) => e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, '')}/>
                                {errors.last_name && <p style={{color:"red"}}>{errors.last_name}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                <span>Primary Phone Number<small className='red_starimpo'>*</small></span>
                                <PhoneInput
                                    placeholder="Enter phone number"
                                    defaultCountry="US"
                                    countries={allowedCountries}
                                    international={false}
                                    limitMaxLength={true}
                                    value={formData.phone_number}
                                    onChange={(value) => handlePhoneChange(value, 'phone_number')}
                                    onKeyDown={(e) => handleKeyDown(e, 'phone_number')}
                                    autoComplete="new-password"
                                />
                                {errors.phone_number && <div className='w-100' style={{color:"red"}} dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(errors.phone_number) }} />}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                <span>Secondary Phone Number</span>
                                <PhoneInput
                                    placeholder="Enter phone number"
                                    defaultCountry="US"
                                    countries={allowedCountries}
                                    international={false}
                                    limitMaxLength={true}
                                    value={formData.secondary_phone_number}
                                    onChange={(value) => handlePhoneChange(value, 'secondary_phone_number')}
                                    onKeyDown={(e) => handleKeyDown(e, 'secondary_phone_number')}
                                    autoComplete="new-password"
                                />
                                {errors.secondary_phone_number && <div className='w-100' style={{color:"red"}} dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(errors.secondary_phone_number) }} />}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                <span>Other Phone Number</span>
                                <PhoneInput
                                    placeholder="Enter phone number"
                                    defaultCountry="US"
                                    countries={allowedCountries}
                                    international={false}
                                    limitMaxLength={true}
                                    value={formData.other_phone_number}
                                    onChange={(value) => handlePhoneChange(value, 'other_phone_number')}
                                    onKeyDown={(e) => handleKeyDown(e, 'other_phone_number')}
                                    autoComplete="new-password"
                                />
                                {errors.other_phone_number && <div className='w-100' style={{color:"red"}} dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(errors.other_phone_number) }} />}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                <span>Primary Email<small className='red_starimpo'>*</small></span>
                                <input type="email"  name="email" value={formData.email} onChange={handleInputChange}/>
                                {errors.email && <div className='w-100' style={{color:"red"}} dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(errors.email) }} />}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                <span>Secondary Email</span>
                                <input type="email"  name="secondary_email" value={formData.secondary_email} onChange={handleInputChange}/>
                                {errors.secondary_email && <div className='w-100' style={{color:"red"}} dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(errors.secondary_email) }} />}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                <span>Other Email</span>
                                <input type="email"  name="other_email" value={formData.other_email} onChange={handleInputChange}/>
                                {errors.other_email && <div className='w-100' style={{color:"red"}} dangerouslySetInnerHTML={{ __html: sanitizeAndDisplayHTML(errors.other_email) }} />}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                <span>Living Country</span>
                                <Select
                                    className="basic-single select_withsearch"
                                    classNamePrefix="select"
                                    value={selectedCountry}
                                    defaultValue={null}
                                    name="living_country"
                                    options={country && country.map((living_country) => ({
                                        label: living_country.name,
                                        value: living_country.code,
                                    }))}
                                    onChange={handleCountryChange}
                                />
                                {errors.living_country && <p style={{color:"Red"}}>{errors.living_country}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                <span>Living State</span>
                                <Select
                                    className="basic-single select_withsearch"
                                    classNamePrefix="select"
                                    value={selectedState}
                                    defaultValue={null}
                                    name="living_state"
                                    options={states && states.map((living_state) => ({
                                        label: living_state.name,
                                        value: living_state.abbreviation,
                                    }))}
                                    onChange={handleStateChange}
                                />
                                {errors.living_state && <p style={{color:"Red"}}>{errors.living_state}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                <span>Living City</span>
                                <Select
                                    className="basic-single select_withsearch"
                                    classNamePrefix="select"
                                    value={selectedCity}
                                    defaultValue={null}
                                    name="living_city"
                                    options={cities && cities.map((living_city) => ({
                                        label: living_city.city_name,
                                        value: living_city.id,
                                    }))}
                                    onChange={handleCityChange}
                                />
                                {errors.living_city && <p style={{color:"Red"}}>{errors.living_city}</p>}
                            </Grid>
                            <Grid size={{sm:5.5, xs:12}} container flexDirection="column">
                                <span>Level</span>
                                <select  name="level" value={formData.level} onChange={handleInputChange}>
                                    <option value="">select</option>
                                    <option value="Level -1">Level -1</option>
                                    <option value="Level 0">Level 0</option>
                                    <option value="Level 1">Level 1</option>
                                    <option value="Level 2">Level 2</option>
                                    <option value="Level 3">Level 3</option>
                                    <option value="Level 4">Level 4</option>
                                    <option value="Level 5">Level 5</option>
                                </select>
                                {errors.level && <p style={{color:"red"}}>{errors.level}</p>}
                            </Grid>
                            <Grid size={{sm:12, xs:12}} container flexDirection="column">
                                <span>Describe relationship with Referrer</span>
                                <textarea type="text" minLength={3} maxLength={4000} className='textarea_community' name="comments" value={formData.comments} onChange={handleInputChange}/>
                                {errors.comments && <p style={{color:"red"}}>{errors.comments}</p>}
                            </Grid>
                        </Grid>
                        {errorsmessage && <p className='mt-3 mb-0' style={{ color: 'red' }}>{errorsmessage}</p>}
                        <Grid size={{sm:12,xs:12}} container justifyContent="flex-start" className="gap-3 mt-4">
                            <button type="submit" className='registersendbtn2'>{btnloading ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Submit'}</button>
                            <button className='registersendbtn1' onClick={()=>navigate("/community-member")}>Cancel</button>
                        </Grid>
                    </form>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default CommunityMemberAdd
